import React from 'react'
import Container from '@material-ui/core/Container';

import { getSystemSettings } from '../../../utils/SettingsRetriever';

import './index.scss';

import Default from './Default';

export default () => {
    const configuration = getSystemSettings();

    return (
    <footer className="footerWrapper">
        <Container className="container" maxWidth="lg">
            <Default configuration={configuration} />
        </Container>
    </footer>);
};
